import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { PrivacyComponent } from './component/privacy/privacy.component';

import { HeaderComponent } from './component/header/header.component';
import {EventlistComponent  } from './component/eventlist/eventlist.component';
import { FooterComponent } from './component/footer/footer.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { EventfilterComponent } from './component/eventfilter/eventfilter.component';
import { FormComponent } from './component/form/form.component';
import { PapsuccessmessageComponent } from './component/papsuccessmessage/papsuccessmessage.component';
import { RouterModule, Routes } from '@angular/router';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { UnsubscribeComponent } from './component/unsubscribe/unsubscribe.component';

const appRoutes: Routes = [
  // { path: '', pathMatch: 'full', component: AppDefaultComponent },
  { path: 'privacy', component: PrivacyComponent },
  { path:'unsubscribe', component: UnsubscribeComponent }
 // {path:'unsubscribe/:id',component: UnsubscribeComponent}
  // { path:'unsubscribe', component: UnsubscribeComponent }
  // { path: '**', component: PageNotFoundComponent }
];

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    HeaderComponent,
    EventlistComponent,
    PrivacyComponent,
    FooterComponent,
    EventfilterComponent,
    FormComponent,
    PapsuccessmessageComponent,
    UnsubscribeComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    RouterModule.forRoot(appRoutes)
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
